/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2026-02-10 16:01:44
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2026-02-10 16:20:53
 * @FilePath: \mall\src\api\movie.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

export function getMovieList() {
  return request({
    url: '/movie/list',
    method: 'get'
  })
}

// 获取电影院列表
export function movieCinemaListApi(data) {
  return request({
    url: '/movie/cinema-list',
    method: 'get',
    params: data
  })
}

// 获取电影院信息
export function movieCinemaInfoApi(data) {
  return request({
    url: '/movie/cinema-info',
    method: 'get',
    params: data
  })
}

// 获取电影院列表
export function movieListApi(data) {
  return request({
    url: '/movie/list',
    method: 'get',
    params: data
  })
}

// 获取电影详情
/*
  film_id: 电影id
*/
export function movieInfoApi(data) {
  return request({
    url: '/movie/info',
    method: 'get',
    params: data
  })
}

// 电影场次

/*
  data:
  获取电影场次
  cinema_id 电影院id
  film_id 电影id
  show_date 场次日期 格式：YYYY-MM-DD 默认当天
  supplier_code 供应商代码
*/
export function movieShowListApi(data) {
  return request({
    url: '/movie/show-list',
    method: 'get',
    params: data
  })
}

// 城市列表
export function movieCityListApi(data) {
  return request({
    url: '/movie/city-list',
    method: 'get',
    params: data
  })
}

/**
 * 获取场次座位图
 * supplier_code 供应商代码
 * show_id 场次id
 * 
 */
export function movieSeatsApi(data) {
  return request({
    url: '/movie/seats',
    method: 'get',
    params: data
  })
}
